import FronthubError from '../../../../core/helpers/FronthubError'
import scanner from './scanner'

import { KEYWORD, TOKEN_TYPE } from './tokens'

export default function tokenizer(grant) {
  if (typeof grant !== 'string')
    throw new FronthubError('rbac grant must be a string', grant)
  const tokens = []
  const stream = grant.split('')
  const scan = scanner(stream)
  let fragment = ''
  let char = scan.read()

  do {
    let match
    if (KEYWORD.NOT.test(fragment + char)) {
      match = tokens.push({ type: TOKEN_TYPE.NOT })
    } else if (KEYWORD.EXTENDS.test(fragment + char)) {
      match = tokens.push({ type: TOKEN_TYPE.EXTENDS })
    } else if (char === ':') {
      match = tokens.push({ type: TOKEN_TYPE.RESOURCE, value: fragment })
    } else if (
      (char === ' ' && scan.lookAhead() === '*') ||
      (char === '*' && !scan.more(1))
    ) {
      match = tokens.push({ type: TOKEN_TYPE.PERMIT_ALL })
    } else if ((fragment + char).length && !scan.more()) {
      if (tokens.length && tokens[tokens.length - 1].type !== TOKEN_TYPE.NOT) {
        match = tokens.push({
          type: TOKEN_TYPE.PERMISSION,
          value: fragment + char,
        })
      } else {
        match = tokens.push({ type: TOKEN_TYPE.ROLE, value: fragment + char })
      }
    }
    if (!match) {
      fragment = fragment + char
    } else {
      fragment = ''
    }
  } while ((scan.more(), (char = scan.read())))
  return tokens
}
